import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
  InputGroup,
  Card,
  Modal,
} from "react-bootstrap";
import { FaPlus, FaSearch, FaShoppingCart, FaTrash } from "react-icons/fa";
import { BiRupee } from "react-icons/bi";
import { RiSave3Line } from "react-icons/ri";
import { LuPrinter } from "react-icons/lu";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import Header from "../Components/Header";

const AddPurchase = () => {
  // const [discounts, setDiscounts] = useState({});
  const [commision, setCommision] = useState(""); // Discount in %
  const [discounts, setDiscounts] = useState("");
  const [packing, setPacking] = useState(""); // Discount in %
  const [gstAmount, setGSTAmount] = useState("");
  const [cart, setCart] = useState([]);
  const [filteredCodes, setFilteredCodes] = useState([]);
  const [products, setProducts] = useState([]);
  const [fullproducts, setFullProducts] = useState([]);
  const [productCode, setProductCode] = useState("");
  const [productName, setProductName] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [loading, setLoading] = useState(true);
  const [Loading1, setLoading1] = useState();
  const [Loading2, setLoading2] = useState();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [sellPrice, setSellPrice] = useState("");
  const [supplierlist, setSupplierList] = useState("")
  const [customer, setCustomer] = useState([]);
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    supplier_name: "",
    address: "",
    mobile: "",
    creditlimit: "",
    gstin: "",
  });
  console.log(searchTerm);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  // Handle Form Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };



  const handlePriceChange = (productId, newPrice) => {
    setSellPrice((prevPrices) => ({
      ...prevPrices,
      [productId]: newPrice, // Store price based on product ID
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      supplier_name: formData.supplier_name,

      gst_number: formData.gst_number,      // FIXED
      mobile: formData.mobile,        // FIXED
      address: formData.address,

    };

    console.log("Payload:", payload);

    try {
      const response = await fetch(`${API_BASE_URL}supplier_add.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("API Response:", data);

      if (data.head.code === 200) {
        alert("Supplier added successfully!");
        setShow(false);
        window.location.reload();
      } else {
        alert("Failed to add Supplier. Error: " + data.head.msg);
      }
    } catch (error) {
      console.error("Network/API Error:", error);
      alert("Required field is empty");
    }
  };

  useEffect(() => {
    axios.post(`${API_BASE_URL}supplier_list.php`)
      .then(response => {
        if (response.data.head.code === 200) {
          setSupplierList(response.data.body);
        } else {
          console.error("Error fetching categories:", response.data.head.msg);
        }
      })
      .catch(error => console.error("API Error:", error));
  }, []);




  useEffect(() => {
    setLoading(true);
    axios
      .post(`${API_BASE_URL}pos_api/pos_product_list.php`)

      .then((response) => {
        if (response.data.head.code === 200) {
          setProducts(response.data.body.product);
          setFullProducts(response.data.body.product);
          console.log(response.data.body.product);
          setCustomer(response.data.body.customer);
           const cgst = response.data.body.gst.cgst;
          const sgst = response.data.body.gst.sgst;
          setGSTAmount(Number(cgst) + Number(sgst));
        } else {
          console.error("Error Fetching Data", response.data.head.msg);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 500); // Delay for better UI
      });
  }, []);

  // Handle product code input with dropdown suggestion
  const handleCodeInput = (event) => {
    const code = event.target.value.trim().toUpperCase();
    setProductCode(code);

    if (code.length === 0) {
      setFilteredCodes([]);
      setProductName("");
      return;
    }

    // Filter products for dropdown suggestions
    const filtered = filteredProducts.filter((p) => p.serial_no.includes(code));
    setFilteredCodes(filtered);

    // Find exact match when full code is entered
    const product = filteredProducts.find((p) => p.serial_no === code);

    if (product) {
      setFilteredCodes([]); // Close dropdow

      setProductName(product.product_name);
      addToCart(product); // ✅ Add only if in stock
    } else {
      setProductName(""); // Clear if no exact match
    }
  };

  // Handle dropdown selection
  const handleDropdownSelect = (product) => {
    setFilteredCodes([]); // Close dropdown

    // Ensure product is valid
    if (!product || !product.serial_no || !product.product_name) {
      alert("Invalid product selection!");
      return;
    }
    setProductCode(product.serial_no);
    setProductName(product.product_name);
    addToCart(product); // ✅ Add to cart only if in stock
  };

  // Handle Product Name Input

  const [filteredProducts, setFilteredProducts] = useState([]);

  // Handle supplier selection
  const handleSupplierChange = (e) => {
    const selectedId = e.target.value;

    // Find selected supplier
    const supplier = supplierlist.find((s) => String(s.id) === String(selectedId));

    setSelectedCustomer(supplier || null); // Update selected supplier

    if (supplier) {
      // Filter products related to the selected supplier
      const supplierProducts = products.filter(
        (product) => String(product.supplier_id) === String(supplier.id)
      );
      setFilteredProducts(supplierProducts);
    } else {
      setFilteredProducts([]); // Reset if no supplier is selected
    }
  };



  // Handle product selection
  const handleNameInput = (event) => {
    const name = event.target.value.trim();
    setProductName(name);

    if (!filteredProducts.length) return; // Ensure products are loaded

    const product = filteredProducts.find(
      (p) => p.product_name.trim().toLowerCase() === name.toLowerCase()
    );

    console.log("Selected Name:", name);
    console.log("Matching Product:", product);

    if (product) {
      if (!product.serial_no) {
        alert("Invalid product details!");
        setProductCode("");
        setProductName("");
        return;
      }

      setProductCode(product.serial_no);
      addToCart(product);
    } else {
      setProductCode("");
    }
  };
  // Add Product to Cart
  const addToCart = (product) => {
    // if (product.stock === 0) {
    //   alert(`"${product.product_name}" is out of stock!`);
    //   return; // Prevent adding to cart
    // }

    setCart((prevCart) => {
      const existingProduct = prevCart.find(
        (item) => item.product_id === product.product_id
      );
      if (existingProduct) {
        if (existingProduct.qty + 1 > product.stock) {
          alert(`Only ${product.stock} items available in stock!`);
          return prevCart;
        }
        return prevCart.map((item) =>
          item.product_id === product.product_id
            ? { ...item, qty: existingProduct.qty + 1 }
            : item
        );
      } else {
        return [...prevCart, { ...product, qty: 1 }];
      }
    });
  };

  const handleQtyChange = (e, product) => {
    let prevQty = product.qty; // Store previous quantity
    let newQty = e.target.value.replace(/^0+/, ""); // Remove leading zeros

    if (newQty === "" || isNaN(newQty)) {
      newQty = "";
    } else {
      newQty = parseInt(newQty, 10);

      // ✅ Ensure new quantity is not less than 1
      if (newQty < 1) {
        newQty = 1;
      }

      // // ✅ Handle stock limit and show alert correctly
      // if (newQty > product.stock) {
      //     alert(`Only ${product.stock} items available in stock!`);
      //     newQty = product.stock; // Reset to max stock
      // }
    }

    // ✅ Update state correctly
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.product_id === product.product_id ? { ...item, qty: newQty } : item
      )
    );
  };

  // ✅ Ensure Minimum Quantity = 1 on Blur
  const handleQtyBlur = (e, product) => {
    let newQty = parseInt(e.target.value, 10) || 1;
    if (newQty < 1) newQty = 1;

    setCart((prevCart) =>
      prevCart.map((item) =>
        item.product_id === product.product_id ? { ...item, qty: newQty } : item
      )
    );
  };
  const [price, setPrice] = useState({});
  const calculateTotal = () => {
    return (
      cart.reduce((total, item) => {
        const basePrice = price[item.product_id]
          ? parseFloat(price[item.product_id])
          : item.purchase_rate;
        return total + basePrice * item.qty;
      }, 0) || 0
    );
  };


  // const cgstAmount = cart.reduce((cgst, item) => {
  //   return (
  //     cgst +
  //     ((item.buy_price - item.buy_price / (1 + item.tax / 100)) / 2) *
  //       item.qty
  //   );
  // }, 0);

  // const sgstAmount = cart.reduce((sgst, item) => {
  //   return (
  //     sgst +
  //     ((item.buy_price - item.sell_price / (1 + item.tax / 100)) / 2) *
  //       item.qty
  //   );
  // }, 0);

  // const grandtotal = Math.round(calculateTotal() + cgstAmount + sgstAmount);

  const removeItem = (id) => {
    setCart(cart.filter((item) => item.product_id !== id));
  };
  // const extractSellPrice = (sellPrice, productId) => {
  //   if (!sellPrice) return "0"; // If undefined/null, return "0"
  //   if (typeof sellPrice === "object") {
  //     return sellPrice[productId] ? String(sellPrice[productId]) : "0"; // Extract value for product_id and convert to string
  //   }
  //   return String(sellPrice); // Convert sellPrice to string if it's already a number or string
  // };

  const calculateNetTotal = () => {
    return (
      cart.reduce((total, item) => {
        const basePrice = price[item.product_id]
          ? parseFloat(price[item.product_id])
          : item.purchase_rate;

        const itemTotal = total + basePrice * item.qty;
        // const discount = parseFloat(item.discount || 0);
        // const discountedTotal = itemTotal - (itemTotal * discount) / 100;

        return itemTotal;
      }, 0) || 0
    );
  };
  const GSTAmount = Math.round((calculateNetTotal() * gstAmount) / 100);
  const total = calculateNetTotal();
  // const commisionAmount = Math.round((total * commision) / 100);
  // const discountAmount = Math.round((total * discounts) / 100);
  // const packingAmount = Math.round((total * packing) / 100);

  const finalTotal = total;
  const grandtotal = Math.round(finalTotal + GSTAmount);

  const handleSave = () => {
    if (!selectedCustomer) {
      alert("Please select a customer.");
      return;
    }
    setLoading1(true);
    if (!cart || cart.length === 0) {
      alert("Please select a product");
      return;
    }

    const orderData = {
      supplier_id: selectedCustomer.id,
      order_date:selectedDate,
      supplier_name: selectedCustomer.supplier_name,
      total: grandtotal,
      subtotal: calculateNetTotal(),
      gst_percentage: gstAmount,
      cgst: GSTAmount / 2,
      sgst: GSTAmount / 2,
      productdetails: cart.map((item) => {

        const buyPrice = price[item.product_id]
          ? parseFloat(price[item.product_id])
          : item.purchase_rate;


        // const discountPercent = discounts[item.product_id] ?? 0;
        const total = buyPrice * item.qty;
        // const netTotal = total - (total * discountPercent / 100);

        return {
          product_id: item.product_id,
          product_name: item.product_name,
          box_contents: item.box_contents,
          count_of_pcs: item.count_of_pcs,
          rate_per: item.rate_per,
          unit: item.unit,
          qty: item.qty,
          amount_per_product: buyPrice,
          // total_per_product: (buyPrice * item.qty).toFixed(2),
          total_per_product: total,
          // discount_percentage: discountPercent,

        };
      }),
    };

    console.log(orderData);
    axios
      .post(`${API_BASE_URL}pos_api/pos_order_purchase.php`, orderData)

      .then((response) => {
        if (response.data.head.code === 200) {
          console.log("Purchase Saved:", response.data);
          alert("Purchase saved successfully!");
          setCart([]);
          window.location.reload();
        } else {
          console.log("Error", response.data.head.msg);
        }
      })
      .catch((error) => {
        console.error("Save Order Error:", error);
        alert("Failed to save order.");
      })
      .finally(() => {
        setLoading1(false);
      });
  };

 

  // Initialize price state when cart data is available
  useEffect(() => {
    if (cart.length > 0) {
      setPrice(
        cart.reduce((acc, item) => ({ ...acc, [item.product_id]: item.purchase_rate * item.count_of_pcs }), {})
      );
    }
  }, [cart]); // Runs when cart updates

  // Handle input change
  const handleBuyPriceChange = (e, productId) => {
    const newPrice = parseFloat(e.target.value) || 0;

    setCart((prevCart) =>
      prevCart.map((item) =>
        item.product_id === productId
          ? { ...item, purchase_rate: newPrice }
          : item
      )
    );
  };
  const handleDiscountChange = (e, productId) => {
    setDiscounts(prev => ({
      ...prev,
      [productId]: value === "" ? "" : Number(value),
    }));
    const value = e.target.value;
    setCart(prev =>
      prev.map(item =>
        item.product_id === productId
          ? { ...item, discount: value }
          : item
      )
    );
  };

  // Handle input change
  const handleBuyPricePerPcsChange = (e, productId) => {
    const newPrice = parseFloat(e.target.value) || 0;

    setCart((prevCart) =>
      prevCart.map((item) =>
        item.product_id === productId
          ? { ...item, purchase_rate: newPrice }
          : item
      )
    );
  };
  // const handleSellPricePerPcsChange = (e, productId) => {
  //   const newPrice = parseFloat(e.target.value) || 0;

  //   setCart((prevCart) =>
  //     prevCart.map((item) =>
  //       item.product_id === productId
  //         ? { ...item, price_per_pcs: newPrice }
  //         : item
  //     )
  //   );
  // };


const [selectedDate, setSelectedDate] = useState("");

    // Convert yyyy-mm-dd to dd-mm-yyyy
    const formatToDDMMYYYY = (dateStr) => {
        if (!dateStr) return "";
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
    };

  return (
    <>
      <Header />
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-body-wrapper">
          <div className="page-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="row">
                    <div className="col-sm-12 m-auto">
                      <div className="card">
                        <div className="card-body">
                          <div className="title-header option-title d-sm-flex d-block">
                            <h5>Add Purchase</h5>
                            <div className="right-options">
                              <ul>
                                <li>
                                  <button
                                    className="btn btn-solid"
                                    onClick={() => window.history.back()}
                                  >
                                    Back
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <Container
                            fluid
                            // className="p-3"
                            style={{ minHeight: "100vh" }}
                          >
                            <Row>
                              <Col
                                md={12}
                                sm={12}
                                className="border-end mt-2"
                                style={{
                                  height: "95vh",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <InputGroup className="mb-3">
                                  <Form.Select value={selectedCustomer ? selectedCustomer.id : ""} onChange={handleSupplierChange}>
                                    <option value="">Select Supplier</option>
                                    {Array.isArray(supplierlist) && supplierlist.map((supplier) => (
                                      <option key={supplier.id} value={supplier.id}>
                                        {supplier.supplier_name}
                                      </option>
                                    ))}
                                  </Form.Select>

                                  {/* Date Input */}
                                              &nbsp;&nbsp;
                                              <Form.Control
                                                  type="date"
                                                  onChange={(e) => {
                                                      const formattedDate = formatToDDMMYYYY(e.target.value);
                                                      setSelectedDate(formattedDate);
                                                  }}
                                                  style={{ maxWidth: "200px" }}
                                              />
                                              &nbsp;&nbsp;
                                  <Button
                                    variant="primary"
                                    onClick={handleShow}
                                    style={{ marginTop: "0px" }}
                                  >
                                    <FaPlus />
                                  </Button>
                                  &nbsp;&nbsp;
                                </InputGroup>


                                <Row>
                                  <Col md={6}>
                                    <InputGroup className="mb-3">
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter Serial No"
                                        value={productCode}
                                        onChange={handleCodeInput}
                                        autoComplete="off"
                                      />
                                      {filteredCodes.length > 0 && (
                                        <div
                                          className="dropdown-menu show"
                                          style={{
                                            width: "100%",
                                            marginTop: "50px",
                                            overflowY: "scroll",
                                            height: "50vh",
                                          }}
                                        >
                                          {filteredCodes.map((product) => (
                                            <div
                                              key={product.product_id}
                                              style={{
                                                cursor: "pointer",
                                                color: "black",
                                              }}
                                              className="dropdown-item"
                                              onClick={() =>
                                                handleDropdownSelect(product)
                                              } // ✅ Separate function for dropdown
                                            >
                                              {product.serial_no} -{" "}
                                              {product.product_name}
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </InputGroup>
                                  </Col>

                                  <Col md={6}>
                                    <InputGroup className="mb-3">
                                      <Form.Select value={productName} onChange={handleNameInput}>
                                        <option value="">Select Product</option>
                                        {filteredProducts.map((product) => (
                                          <option key={product.product_id} value={product.product_name}>
                                            {product.product_name}
                                          </option>
                                        ))}
                                      </Form.Select>

                                    </InputGroup>
                                  </Col>
                                </Row>

                                {/* Table to Display Selected Products */}
                                <div
                                  style={{
                                    flexGrow: 1,
                                    overflowY: "auto",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  <Table bordered responsive>
                                    <thead>
                                      <tr>
                                        <th style={{ width: "5%" }}>Sno</th>
                                        <th style={{ width: "20%" }}>Item</th>
                                        <th
                                          style={{
                                            width: "10%",
                                            textAlign: "right",
                                          }}
                                        >
                                          Purchase Rate
                                        </th>
                                        
                                        <th style={{ width: "10%" }}>Qty</th>
                                        <th
                                          style={{
                                            width: "10%",
                                            textAlign: "right",
                                          }}
                                        >
                                          Total
                                        </th>
                                        {/* <th style={{ width: "10%", textAlign: "right" }}>Discount (%)</th>
                                        <th style={{ width: "10%", textAlign: "right" }}>Net Total</th> */}
                                        <th style={{ width: "5%" }}>Del</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {cart.map((item, index) => {
                                        const total = item.purchase_rate * item.qty;
                                        // const total =
                                        //  (price[item.product_id]
                                        //     ? parseFloat(price[item.product_id])
                                        //     : purchaseRate) * item.qty; 
                                            // console.log("=====================",price[item.product_id]);
                                        // const discount = parseFloat(item.discount || 0);
                                        // const netTotal = total - (total * discount) / 100;

                                        return (
                                          <tr key={item.product_id}>
                                            <td>{index + 1}</td>
                                            <td>{item.product_name} - ({item.serial_no})</td>
                                            <td style={{ textAlign: "right" }}>
                                              <BiRupee />
                                              <input
                                                type="number"
                                                 step="any"    
                                                value={item.purchase_rate}
                                                onChange={(e) => handleBuyPricePerPcsChange(e, item.product_id)}
                                                style={{
                                                  width: "80px",
                                                  padding: "5px",
                                                  textAlign: "right",
                                                  border: "1px solid #ccc",
                                                  borderRadius: "4px",
                                                }}
                                              />
                                            </td>
                                            
                                            <td>
                                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <input
                                                  type="number"
                                                  
                                                  value={item.qty}
                                                  min="1"
                                                  className="form-control text-center"
                                                  style={{ width: "60px" }}
                                                  onInput={(e) =>
                                                    handleQtyChange(e, item)
                                                  }
                                                  onBlur={(e) =>
                                                    handleQtyBlur(e, item)
                                                  }
                                                />
                                              
                                              </div>
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                              <BiRupee />
                                              {total.toFixed(2)}
                                            </td>
                                            {/* <td style={{ textAlign: "right" }}>
                                              <input
                                                type="number"
                                                 step="any"  // 👈 Add this
                                                min="0"
                                                max="100"
                                                value={item.discount || ""}
                                                onChange={(e) =>
                                                  handleDiscountChange(e, item.product_id)
                                                }
                                                style={{
                                                  width: "80px",
                                                  padding: "5px",
                                                  textAlign: "right",
                                                  border: "1px solid #ccc",
                                                  borderRadius: "4px",
                                                }}
                                              />
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                              <BiRupee />
                                              {netTotal.toFixed(2)}
                                            </td> */}
                                            <td>
                                              <Button
                                                variant="danger"
                                                size="sm"
                                                onClick={() =>
                                                  removeItem(item.product_id)
                                                }
                                              >
                                                <FaTrash />
                                              </Button>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </Table>
                                </div>

                                <div className="bg-light p-3 border rounded d-flex justify-content-between print-btn-group">
                                  {/* {selectedCustomer &&
                                  selectedCustomer.is_bill_eligible <
                                    calculateTotal() ? (
                                    <h5
                                      style={{
                                        color: "red",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {" "}
                                      Purchase Limit Exceeded
                                    </h5>
                                  ) : (
                                    <> */}
                                  <div className="print-btn">
                                    <Button
                                      variant="dark"
                                      onClick={handleSave}
                                      style={{
                                        width: "80px",
                                        height: "40px",
                                      }}
                                    >
                                      {Loading1 ? (
                                        <Spinner
                                          animation="border"
                                          size="sm"
                                        />
                                      ) : (
                                        <>
                                          <RiSave3Line /> &nbsp; Save
                                        </>
                                      )}
                                    </Button>
                                    &nbsp;&nbsp;
                                    {/*  <Button variant="dark"  onClick={handleSavePrint} style={{width:"130px",height:"40px"}}>
                                        {Loading2 ? (
                                              <Spinner animation="border" size="sm" />
                                            ) : (
                                              <>
                                          <LuPrinter />&nbsp; Save & Print
                                          </>
                                            )}
                                          </Button> */}
                                  </div>
                                  {/*  </>
                                  )} */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "5px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "250px",
                                      }}
                                    >
                                      <h6
                                        style={{
                                          color: "black",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Subtotal:
                                      </h6>
                                      <h6
                                        style={{
                                          color: "black",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        <BiRupee />
                                        {calculateNetTotal().toFixed(2)}

                                      </h6>
                                    </div>
                                    <div style={{ fontWeight: "bold" }}>
                                                    <h6 style={{ color: "black", fontWeight: "bold" }}>
                                                      <input
                                                        type="number"
                                                        placeholder="Enter GST %"
                                                        value={gstAmount}
                                                        onChange={(e) => setGSTAmount(Number(e.target.value))}
                                                        style={{
                                                          padding: "6px",
                                                          fontSize: "14px",
                                                          borderRadius: "4px",
                                                          border: "1px solid #ccc",
                                                          width: "100%"
                                                        }}
                                                      />
                                                    </h6>
                                                  </div>
                                                  <div style={{ display: "flex", justifyContent: "space-between", width: "250px", fontWeight: "bold" }}>
                                                    <h6 style={{ color: "black", fontWeight: "bold" }}>GST Amount:</h6>
                                                    <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{GSTAmount.toFixed(2)}</h6>
                                                  </div>
                                    {/* <div style={{ fontWeight: "bold" }}>
                                      <h6 style={{ color: "black", fontWeight: "bold" }}>
                                        <input
                                          type="number"
                                           step="any"    
                                          placeholder="Enter Discount %"
                                          value={discounts}
                                          onChange={(e) => setDiscounts(Number(e.target.value))}
                                          style={{
                                            padding: "6px",
                                            fontSize: "14px",
                                            borderRadius: "4px",
                                            border: "1px solid #ccc",
                                            width: "100%"
                                          }}
                                        />
                                      </h6>
                                    </div>


                                    <div style={{ display: "flex", justifyContent: "space-between", width: "250px", fontWeight: "bold" }}>
                                      <h6 style={{ color: "black", fontWeight: "bold" }}>Discount Amount:</h6>
                                      <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{discountAmount.toFixed(2)}</h6>
                                    </div> */}
                                    {/* <div style={{ fontWeight: "bold" }}>
                                      <h6 style={{ color: "black", fontWeight: "bold" }}>
                                        <input
                                          type="number"
                                           step="any"    
                                          placeholder="Enter Commision %"
                                          value={commision}
                                          onChange={(e) => setCommision(Number(e.target.value))}
                                          style={{
                                            padding: "6px",
                                            fontSize: "14px",
                                            borderRadius: "4px",
                                            border: "1px solid #ccc",
                                            width: "100%"
                                          }}
                                        />
                                      </h6>
                                    </div>


                                    <div style={{ display: "flex", justifyContent: "space-between", width: "250px", fontWeight: "bold" }}>
                                      <h6 style={{ color: "black", fontWeight: "bold" }}>Commision Amount:</h6>
                                      <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{commisionAmount.toFixed(2)}</h6>
                                    </div> */}
                                    {/* Packing Input */}
                                    {/* <div style={{ fontWeight: "bold" }}>
                                       <h6 style={{ color: "black", fontWeight: "bold" }}>
                                        <input
                                          type="number"
                                           step="any"    
                                          placeholder="Enter packing %"
                                          value={packing}
                                          onChange={(e) => setPacking(Number(e.target.value))}
                                          style={{
                                            padding: "6px",
                                            fontSize: "14px",
                                            borderRadius: "4px",
                                            border: "1px solid #ccc",
                                            width: "100%"
                                          }}
                                        />
                                      </h6>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "space-between", width: "250px", fontWeight: "bold" }}>
                                      <h6 style={{ color: "black", fontWeight: "bold" }}>Packing Amount:</h6>
                                      <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{packingAmount.toFixed(2)}</h6>
                                    </div> */}

                                 
                                    <div style={{ display: "flex", justifyContent: "space-between", width: "250px", fontWeight: "bold" }}>
                                      <h6 style={{ color: "black", fontWeight: "bold" }}>Grand Total:</h6>
                                      <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{grandtotal.toFixed(2)}</h6>
                                    </div>
                                  </div>
                                </div>
                              </Col>


                            </Row>
                            {/* -------------Customer Add Modal  Start --------------- */}
                            <Modal show={show} onHide={handleClose} centered>
                              <Modal.Header closeButton>
                                <Modal.Title>Add Supplier</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <Form onSubmit={handleSubmit}>
                                  {/* Customer Name */}
                                  <Form.Group className="mb-3">
                                    <Form.Label>Supplier Name</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="supplier_name"
                                      value={formData.supplier_name}
                                      onChange={handleChange}
                                      placeholder="Enter Supplier Name"
                                      required
                                    />
                                  </Form.Group>

                                  <Form.Group className="mb-3">
                                    <Form.Label>Phone Number</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="mobile"
                                      value={formData.mobile}
                                      onChange={handleChange}
                                      placeholder="Enter Phone Number"
                                      required
                                      maxLength={10}
                                    />
                                  </Form.Group>

                                  {/*  <Form.Group className="mb-3">
                                    <Form.Label>Credit Limit</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="creditlimit"
                                      value={formData.creditlimit}
                                      onChange={handleChange}
                                      placeholder="Enter Credit Limit"
                                    />
                                  </Form.Group> */}

                                  {/* Address */}
                                  <Form.Group className="mb-3">
                                    <Form.Label>Address</Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      name="address"
                                      value={formData.address}
                                      onChange={handleChange}
                                      placeholder="Enter Address"
                                      rows={3}
                                    />
                                  </Form.Group>

                                  {/* GSTIN/UIN */}
                                  <Form.Group className="mb-3">
                                    <Form.Label>GSTIN/UIN</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="gstin"
                                      value={formData.gstin}
                                      onChange={handleChange}
                                      placeholder="Enter GSTIN/UIN"
                                      maxLength={15}
                                    />
                                  </Form.Group>

                                  {/* Submit Button */}
                                  <Button variant="success" type="submit">
                                    Submit
                                  </Button>
                                </Form>
                              </Modal.Body>
                            </Modal>
                            {/* -------------Customer Add Modal  End --------------- */}
                          </Container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPurchase;
